import i, { forwardRef as q, useState as G } from "react";
import { textInputDefaultProps as b } from "./props.js";
import "clsx";
import { runInputValidations as H } from "../../helpers/inputValidation.js";
import { validation as A } from "../TextArea/utils.js";
import { useUniqueId as O } from "../../hooks/useUniqueId.js";
import "./components/ButtonPassword.js";
import { Container as U } from "./components/Container.js";
import { Input as J } from "./components/Input.js";
import { InputGroup as K } from "./components/InputGroup.js";
import { LimitText as Q } from "./components/LimitText.js";
import { RightComponent as X } from "./components/RightComponent.js";
import { FormControl as R, FormControlLabel as Y, FormControlErrorORCaption as Z } from "../FormControl/FormControl.js";
var $ = Object.defineProperty,
  p = Object.getOwnPropertySymbols,
  L = Object.prototype.hasOwnProperty,
  z = Object.prototype.propertyIsEnumerable,
  S = (e, a, t) => a in e ? $(e, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[a] = t,
  ee = (e, a) => {
    for (var t in a || (a = {})) L.call(a, t) && S(e, t, a[t]);
    if (p) for (var t of p(a)) z.call(a, t) && S(e, t, a[t]);
    return e;
  },
  te = (e, a) => {
    var t = {};
    for (var r in e) L.call(e, r) && a.indexOf(r) < 0 && (t[r] = e[r]);
    if (e != null && p) for (var r of p(e)) a.indexOf(r) < 0 && z.call(e, r) && (t[r] = e[r]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const x = q((e, a) => {
  const t = e,
    {
      "aria-label": r,
      className: y,
      display: N,
      iconLeft: E,
      iconRight: P,
      id: d,
      type: c = b.type,
      link: w,
      margin: C,
      marginBottom: B,
      marginLeft: D,
      marginRight: M,
      marginTop: V,
      label: l,
      disabled: m,
      caption: _,
      stateMessage: s,
      state: o,
      width: j,
      size: n = b.size,
      limitTextSize: v
    } = t,
    f = te(t, ["aria-label", "className", "display", "iconLeft", "iconRight", "id", "type", "link", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "label", "disabled", "caption", "stateMessage", "state", "width", "size", "limitTextSize"]);
  H({
    "aria-label": r,
    id: d,
    label: l,
    state: o,
    stateMessage: s
  });
  const g = A(v),
    h = O("ds-text-input-limittext"),
    I = O("ds-text-input-error"),
    [T, F] = G(c),
    W = () => {
      F(k => k === "password" ? "text" : "password");
    },
    u = o === "error" && !!s && !m;
  return i.createElement(U, {
    width: j,
    className: y,
    margin: C,
    marginLeft: D,
    marginBottom: B,
    marginTop: V,
    marginRight: M,
    display: N
  }, (!!l || !!w) && i.createElement(R, {
    marginBottom: "--spacing-1"
  }, i.createElement(Y, {
    size: n,
    htmlFor: d
  }, l), w), i.createElement(K, {
    value: f.value,
    state: o,
    size: n,
    disabled: m
  }, E && i.createElement("span", {
    className: "olx-text-input__icon-wrapper",
    "data-position": "left",
    "data-size": n
  }, E), i.createElement(J, ee({
    id: d,
    type: c,
    typePassword: T,
    ariaLabel: r,
    state: o,
    errorId: I,
    hasLimitText: g,
    limitTextID: h,
    disabled: m,
    size: n,
    className: y,
    label: l,
    ref: a
  }, f)), i.createElement(X, {
    state: o,
    iconRight: P,
    disabled: m,
    stateMessage: s,
    type: c,
    size: n,
    typePassword: T,
    alterTypeInput: W
  })), (!!_ || u || !!g) && i.createElement(R, {
    marginTop: "--spacing-1"
  }, i.createElement(Z, {
    hasError: u,
    id: I
  }, u ? s : _), i.createElement(Q, {
    hasLimitText: !!g,
    limitTextID: h,
    limitTextSize: v,
    value: f.value
  })));
});
x.defaultProps = b, x.displayName = "TextInput";
export { x as TextInput };